
import paths from '../../routes/paths';

const eventMap = {
  [paths.createOrder.complete]: { action: 'ordercomplete', category: 'Medicine Ordered', label: 'New order' },
  [paths.signup.complete]: { action: 'signupcomplete', category: 'Sign ups', label: 'New lead' },
};

const mapEvent = route => eventMap[route] || null;

const sendUET = (w, evts) => () => next => {
  const evt = mapEvent(w.location.pathname);
  if (evt === null) {
    return action => next(action);
  }
  evts.push('event', evt.action, { event_category: evt.category, event_label: evt.label, event_value: '1' });
  return action => next(action);
};

export default sendUET;
